module.exports = __webpack_public_path__ + "static/media/calisthenics.3ba5c978.jpg";